export enum LayoutBreakpoints {
  SmallMobile = 360,
  Tablet = 768,
  Laptop = 900,
  Desktop = 1262
}
